import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ConfirmationProvider } from "./components/ConfirmationModal";
import { ToastProvider } from "./components/Toast";
import AppRoutes from "./routes/AppRoutes";
import { AlertProvider } from "./components/AlertModal";
import { PageOptionProvider } from "./components/PageOptionModal";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider autoClose={5000}>
        <ConfirmationProvider>
          <PageOptionProvider>
            <AlertProvider>
              <AppRoutes />
            </AlertProvider>
          </PageOptionProvider>
        </ConfirmationProvider>
      </ToastProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
